module.exports = __webpack_public_path__ + "static/media/guarantee@2x.54a2ff23.png";